import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  TextField,
  Button,
  Box,
} from "@mui/material";

const INITIAL_VALUES = { name: "" };

export default function ContainerOptionFormDialog({ open, onClose, onSave, rowId, containerOption }) {
  const [data, setData] = useState(INITIAL_VALUES);
  
  useEffect(() => {
    if (!open) return;

    if (rowId && containerOption) {
      setData({
        name: containerOption.name ?? "",
      });
    } else {
      setData(INITIAL_VALUES);
    }
  }, [rowId, containerOption, open]);

  const handleClose = () => {
    setData(INITIAL_VALUES);
    onClose();
  };

  const nameTrimmed = (data.name ?? "").trim();
  const isValid = nameTrimmed !== "";

  const handleSave = () => {
    onSave({ name: nameTrimmed });
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{rowId ? "Edit Container Option" : "Create Container Option"}</DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ mb: 3 }}>
          {rowId
            ? "Update the name of the container option."
            : "Enter a name for the new container option (e.g. Bottle, Keg, Box, Can)."}
        </DialogContentText>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <TextField
            label="Name"
            fullWidth
            required
            autoComplete="off"
            value={data.name}
            onChange={(e) => setData({ ...data, name: e.target.value })}
            helperText="e.g. Bottle, Keg, Box, Can"
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={!isValid}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
